import iziToast from "izitoast";
import "izitoast/dist/css/iziToast.min.css";
import { defineNuxtPlugin } from "#app";
export default defineNuxtPlugin(async () => {
  const THEMES = {
    info: { color: "blue", icon: "ico-info" },
    success: { color: "green", icon: "ico-success" },
    warning: { color: "orange", icon: "ico-warning" },
    error: { color: "red", icon: "ico-error" },
    question: { color: "yellow", icon: "ico-question" }
  };
  return {
    provide: {
      iziToast: {
        ...iziToast,
        hideToast(title, message, status) {
          const color = THEMES[status].color;
          const newId = btoa(encodeURIComponent(`${title}${message}${color}`)).replace(/=/g, "");
          document.querySelectorAll(`.iziToast#${newId}`).forEach(
            (element) => element instanceof HTMLDivElement && iziToast.hide({ title, message, id: newId }, element, "replaced")
          );
        },
        data(data) {
          iziToast.show({
            ...data,
            color: THEMES[data?.status]?.color,
            icon: THEMES[data?.status]?.icon,
            timeout: data.timeout ?? 2500
          });
        }
      }
    }
  };
});
